import axios from 'axios';
import config from '../config/env-constants';


function getProjectId() {
    if (config.currEnv === 'pjl' || config.currEnv === 'kooler') {
        return `ayun-${config.currEnv}`;
    } else {
        return `ares-${config.currEnv}-app`;
    }
}

export default {

    baseUrl: `https://us-central1-${getProjectId()}.cloudfunctions.net`,

    createFaq(params, currUserId) {
        const url = `${this.baseUrl}/createFaq`;
        return axios.post(url, {
            currUserId,
            ...params
        });
    },

    updateFaq(params, currUserId) {
        const url = `${this.baseUrl}/updateFaq`;
        return axios.post(url, {
            currUserId,
            ...params
        });
    }
}